import React from 'react';
import PropTypes from 'prop-types';
import { getStyles } from '../../../../../shared/utility';

import TextClamp from '../../../../UI/TextClamp/TextClamp';
import Input from '../../../../UI/Input/Input';
import Bar from '../../../../UI/Loading/Bar/Bar';

import userPlaceholder from '../../../../../assets/images/img-contact-placeholder.svg';

import menuStyles from '../../Menu.scss';
const styles = getStyles(menuStyles);

const paymentAccountToggle = (props) => (props.loading ? new Array(3).fill() : props.items).map((item, key) => (
    <li key={key} className={styles('menu__item', 'dropdown__item')}>
        {props.loading ? (
            <div className={styles('menu__content')}>
                <span className={styles('flex', 'flex--align-center', 'menu__content__padded-content')}>
                    <div className={styles('menu__image', 'menu__image--empty')}/>
                    <p className={styles('menu__text', 'line-height--small')}>
                        <Bar modifiers={['no-animation', 'darker']}/><br />
                        <Bar modifiers={['no-animation']}/>
                    </p>
                </span>
            </div>
        ) : (
            <Input
                attrs={{ type: 'radio' }}
                value={item.id}
                checked={props.selected === item.id}
                events={{ change: () => props.change(item.id) }}
                modifiers={['right', 'stretch']}
                labelClasses={styles('menu__content')}
                labelContentClasses={styles('flex', 'flex--align-center', 'flex--justify-between')}
            >
                {item.imageReference || item.accountType === 'personal' ?
                    <img src={item.imageReference ? item.imageReference.source : userPlaceholder} alt="" className={styles('menu__image', 'menu__image--contain', 'menu__image--border', 'circle')} /> :
                    <div className={styles('menu__image', 'menu__image--empty')}/>
                }
                <p className={styles('menu__text', 'line-height--small')}>
                    <strong className={styles('menu__text__block')}>
                        <TextClamp lines={2}>{item.companyReference ? item.companyReference.name : props.userName}</TextClamp>
                    </strong>
                    <span className={styles('c--text-light')}>{item.accountType}</span>
                </p>
            </Input>
        )}
    </li>
));

paymentAccountToggle.propTypes = {
    // properties
    items: PropTypes.arrayOf(PropTypes.object),
    selected: PropTypes.any,
    loading: PropTypes.bool,
    userName: PropTypes.string.isRequired,

    // functions
    change: PropTypes.func.isRequired
};

export default paymentAccountToggle;



// WEBPACK FOOTER //
// ./src/components/Navigation/Menu/SubMenu/PaymentAccountToggle/PaymentAccountToggle.js